import selectApiImpl from '../api/select-api';
import readerServiceImpl from '../services/reader-service';
import { forecastFrenzyWidget as forecastFrenzyWidgetImpl } from '../widgets/forecast-frenzy-widget';
import type { DeepDiveWidget } from '@/core/widgets/export';
import { hscWidget as hscWidgetImpl } from '../widgets/hsc-widget';
import type { SelectApi, ReaderService } from './contracts';

export type { NewsEvent, SelectApi, ReaderService } from './contracts';
export { CalendarContext, default as CalendarProvider } from '../contexts/calendar-context';
export { default as DataDownload } from '../components/data-download/data-download';
export { default as ReaderIndicator } from '../components/reader-indicator';
export { default as DataHistoryChatEmbed } from '../chat/data-history-chat-embed';
export { eventSearchResultType } from '../search/event-search-result-type';
export { DataCalendarWidget } from '../widgets/calendars/data-calendar-widget';
export { SingleCalendarWidgetFactory } from '../widgets/calendars/single-calendar-widget';
export { TabsCalendarWidgetFactory } from '../widgets/calendars/tabs-calendar-widget-factory';
export { DataReleaseHistoryWidget } from '../widgets/data-release-history-widget';
export { HotListWidget } from '../widgets/hot-list-widget';
export const selectApi: SelectApi = selectApiImpl;
export const readerService: ReaderService = readerServiceImpl;
export const forecastFrenzyWidget: DeepDiveWidget = forecastFrenzyWidgetImpl;
export const hscWidget: DeepDiveWidget = hscWidgetImpl;
